import React, { createContext, useState, useContext, useEffect } from "react";
import { getSettings } from "../services/api";

const StoreContext = createContext();

export const useStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error("useStore must be used within a StoreProvider");
  }
  return context;
};

export const StoreProvider = ({ children }) => {
  const [storeClosed, setStoreClosed] = useState(false);
  const [storeClosedMessage, setStoreClosedMessage] = useState("");

  useEffect(() => {
    getSettings()
      .then((response) => {
        const { storeClosed, storeClosedMessage } = response.data.settings;
        setStoreClosed(!!storeClosed);
        setStoreClosedMessage(storeClosedMessage || "");
      })
      .catch(() => {
        // En cas d'erreur, la boutique reste ouverte par défaut
      });
  }, []);

  return (
    <StoreContext.Provider value={{ storeClosed, storeClosedMessage }}>
      {children}
    </StoreContext.Provider>
  );
};
